import React, { useRef } from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import { DetailView } from './detail-view';;
import useAccountForms from 'src/api/accounts/vm-form';
import useAssignForms from 'src/api/assign/vm-form';
import useToast from 'src/utils/toast-utils';
import { useCallbackAction } from 'src/hooks/use-actions';
import PageSection from 'src/layouts/page-section';

const Page = ({ onNavigate, item, options }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const childRef = useRef();
  const { changeAccountNote, blockAccount } = useAccountForms();
  const { accountToGroup, carToAccount } = useAssignForms();
  const { toastSuccess, toastError } = useToast();

  const apiUpdate = (values) => useCallbackAction(changeAccountNote, values, 
        (result) => {
          toastSuccess(`Đã cập nhật ${result?.accountId}`, {action: 'back'});
        }, toastError);

  const apiBlockAcc = (values) => useCallbackAction(blockAccount, values, 
        (result) => { 
          toastSuccess(`Đã khóa ${result.id}`, {action: 'back'}); 
        }, toastError );

  const assignToCar = (values) => useCallbackAction(carToAccount, values,
        (result) => { 
          const msg = (result === '0') ? 'Đã thu thồi xe': `Đã giao xe ${result}`;
          toastSuccess(msg);
          childRef.current?.onCarAssigned(result); 
        }, toastError );

  const assignToGroup = (values) => useCallbackAction(accountToGroup, values,
        (result) => { 
          const msg = `Đã chuyển đơn vị ${result}`;
          toastSuccess(msg);
          childRef.current?.onGroupAssigned(result); 
        }, toastError );
        
  return (
    <PageSection title="Teacher" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.teachers)}
          subLabel={item?.code}
        />
        <Stack spacing={1}>
          <DetailView ref={childRef} item={item} options={options} 
              apiUpdate={apiUpdate} blockAccount={apiBlockAcc}
              assignCar={assignToCar} assignGroup={assignToGroup} />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;